import React, { useEffect, useMemo } from "react";
import { observer } from "mobx-react-lite";
import { useStores } from "_common/hooks";
import { Link, useNavigate, useSearchParams } from "react-router-dom";

const Trade = observer(() => {
  const navigate = useNavigate();

  const {
    authStore: { banners, top_coin, games, authenticated },
  } = useStores();

  return (
    <div className="mx-auto max-full lg:max-w-[1140px] 2xl:max-w-[1320px] px-6 hero-animate">
      <div className="grid grid-cols-12 pb-[80px] lg:pb-[120px]  items-center ">
        <div className="col-span-12 lg:col-span-6 lg:mr-[50px] order-[2] lg:order-[1]  ">
          <div className="w-full">
            <h2 className="text-[#fff] text-[32px] mt-0 mb-2 leading-[1.2] font-medium">
              In the digital world, we are secure &amp; trustworthy
            </h2>
            <div className="text-[#fff] mb-4">
              TOCOM is one of the largest and safest platforms out there. The
              best digital wallets provide a good mix of security tools and
              user-facing features at a reasonable cost.
            </div>
            <ul className="flex flex-col mt-[35px]">
              <li className="flex gap-3 mb-[15px] pl-8">
                <div>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="10" cy="10" r="10" fill="#2C04FE" />
                    <path
                      d="M15.043 6.238a.803.803 0 00-1.142 0l-5.991 6-2.517-2.526a.822.822 0 10-1.142 1.182l3.088 3.088a.805.805 0 001.142 0l6.562-6.562a.804.804 0 000-1.182z"
                      fill="#fff"
                    />
                  </svg>
                </div>
                <span className=" mt-[-4px] text-[#fff] text-[18px] font-semibold">
                  Cost-effective mode of transaction secure and private.
                </span>
              </li>
              <li className="flex gap-3 mb-[15px] pl-8">
                <div>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="10" cy="10" r="10" fill="#2C04FE" />
                    <path
                      d="M15.043 6.238a.803.803 0 00-1.142 0l-5.991 6-2.517-2.526a.822.822 0 10-1.142 1.182l3.088 3.088a.805.805 0 001.142 0l6.562-6.562a.804.804 0 000-1.182z"
                      fill="#fff"
                    />
                  </svg>
                </div>
                <span className=" mt-[-4px] text-[#fff] text-[18px] font-semibold">
                  Self-governed managed all and easy transfer of funds.
                </span>
              </li>
              <li className="flex gap-3 mb-[15px] pl-8">
                <div>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="10" cy="10" r="10" fill="#2C04FE" />
                    <path
                      d="M15.043 6.238a.803.803 0 00-1.142 0l-5.991 6-2.517-2.526a.822.822 0 10-1.142 1.182l3.088 3.088a.805.805 0 001.142 0l6.562-6.562a.804.804 0 000-1.182z"
                      fill="#fff"
                    />
                  </svg>
                </div>
                <span className=" mt-[-4px] text-[#fff] text-[18px] font-semibold">
                  Currency exchanges finish smoothly and decentralized.
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div className="relative text-right  col-span-12 lg:col-span-6  order-[1] lg:order-[2] mb-[50px] lg:mb-0 ">
          <div className="relative z-[4] inline-block ">
            <div className="absolute z-[3] top-[-23%] right-[0%] ">
              <img
                className="relative z-[2]"
                src="https://api.demo92.apptestlive.com/assets/images/shapes-round.png "
                alt=""
              />
              <div className="absolute z-[1] w-[150px] h-[150px] top-[-35px] left-[-35px] rounded-[100%] bg-[#2c04fe26] waves" />
            </div>
            <div className="absolute z-[3] bottom-[25%] left-[70px]">
              <img
                className="relative z-[2]"
                src="https://api.demo92.apptestlive.com/assets/images/shapes-round.png "
                alt=""
              />
              <div className="absolute z-[1] w-[150px] h-[150px] top-[-35px] left-[-35px] rounded-[100%] bg-[#2c04fe26] waves" />
            </div>
            <img
              className=" relative z-[4] max-w-full"
              src="https://api.demo92.apptestlive.com/assets/images/content-thumb.webp"
              alt=""
            />
          </div>
        </div>
      </div>
      <div className="grid grid-cols-12 ">
        <div className="col-span-12 lg:col-span-6 text-left mb-[30px] lg:mb-0 lg:mr-[50px]  ">
          <div className="relative  z-[2] inline-block ">
            <img
              className="relative z-[2] max-w-full "
              src="https://api.demo92.apptestlive.com/assets/images/content-thumb2.webp"
              alt=""
            />
            <div className="absolute z-[2] bottom-[10px] right-0 lg:right-[-90px]  bitcoin">
              <img
                className=""
                src="https://api.demo92.apptestlive.com/assets/images/bitcoin4.webp "
                alt=""
              />
            </div>
            <div className=" hidden lg:block absolute z-[1] w-[161%] h-[90%] top-[0%] left-[-35%] ">
              <img
                className="w-full h-full rounded-[3px]"
                src="https://api.demo92.apptestlive.com/assets/images/shape-video.webp"
                alt=""
              />
            </div>
          </div>
        </div>
        <div className="col-span-12 lg:col-span-6 ">
          <div className="w-full">
            <h2 className="text-[#fff] text-[32px] mt-0 mb-2 leading-[1.2]">
              Easy step to use TOCOM to invest on any device
            </h2>
            <div className="flex flex-col gap-4">
              <span className="text-[#fff]">
                While the concept is simple a place to store your assets &amp;
                use choosing TOCOMcan be an incredibly experience.
              </span>
              <a
                className="relative group  w-fit flex items-center justify-center cursor-pointer "
                href="/m"
              >
                <div className="absolute top-0 left-0 group-hover:top-[5px] group-hover:left-[5px] bg-[#fff] duration-300 ease-in-out w-full h-full rounded-[4px]" />
                <div className="relative text-[#000] bg-[#f7a600] px-[36px] py-4 font-bold  rounded-[4px]">
                  Go To Exchange
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default Trade;
